import { action, observable } from 'mobx';

import AuthStore from 'bz-stores/lib/auth-store';
import Api from 'tm3-core/api';
import type { CurrentUser } from 'tm3-core/api.dtos';

import JsonServiceClient from 'bz-stores/lib/JsonServiceClient';
import { FidoStore } from './fido-store';

class LoginStore {
  @observable authenticating: boolean = true;
  @observable authenticated: boolean = false;
  @observable loginObject: any = observable({ userName: '', password: '' });
  @observable loadingAuth: boolean = false;
  @observable newPasswordObject: any = observable({ loadingAuth: true });
  @observable message: string = '';
  client = new JsonServiceClient();
  fidoStore = new FidoStore();

  @action.bound
  async login(login: any, failedLogin?: any) {
    this.loadingAuth = true;

    try {
      const res = ((await Api.post('/api/auth/credentials', login)) as any).body as CurrentUser;
      return this.onAuthenticatedLogin(res);
    } catch (err: any) {
      this.message = 'There was a problem logging you in, please try again shortly';
      let { body } = err.response || err;

      if (body && body.responseStatus) {
        this.message = body.responseStatus.message;
      }

      this.loadingAuth = false;
      this.loginObject = {
        userName: login.userName,
        password: '',
        email: login.userName
      };
      return Promise.reject(this.message);
    }
  }

  @action.bound
  logout(storeReset = true) {
    AuthStore.logout(storeReset);
  }

  @action.bound
  onAuthenticatedLogin(res: CurrentUser): boolean {
    this.loadingAuth = false;
    this.authenticating = false;
    const result = AuthStore.onAuthenticate(res, false, true);
    if (result) {
      AuthStore.initialiseStores();
    }

    return result;
  }

  async onFidoLogin() {
    const res = await this.fidoStore.onFidoLogin();
    if (res) {
      await AuthStore.checkLoginState();
    }
    return res;
  }
}

export default LoginStore;
